import React from "react";
import Cards from "../components/dashboard/card/Cards";
import FilterSub from "../../components/filter/FilterSub";
import Companies from "./Companies";

const AdminDashboard = () => {
  return (
    <div>
      <section>
        <FilterSub />
      </section>
      <Cards />

      <section>
        <Companies />
      </section>
    </div>
  );
};

export default AdminDashboard;
